import { createI18nText } from '@hilma/netina2all';

const contactUsText = createI18nText({
	he: {
		title: 'צרו איתנו קשר',
		name: 'שם מלא',
		email: 'כתובת מייל',
		phone: 'טלפון נייד',
		purchaseId: 'מספר הזמנה',
		message: 'איך אפשר לעזור?',
		contactBtn: 'שלח',
		popUp: {
			title: 'פנייתך נשלחה בהצלחה!',
			text: 'תודה, נחזור אליך בהקדם',
			btn: 'חזרה לעמוד הבית'
		},
	},
	en: {
		title: 'Contact Us',
		name: 'Full Name',
		email: 'Email Address',
		phone: 'Phone Number',
		purchaseId: 'Order Number',
		message: 'How Can We Help?',
		contactBtn: 'Send',
		popUp: {
			title: 'Your request has been sent successfully!',
			text: 'We will get back to you shortly',
			btn: 'Home'
		},
	}
});

export default contactUsText;